import { motion } from "framer-motion";

// Shared framer-motion variants used across the site for consistent, tasteful motion.

export const EASE_OUT = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: EASE_OUT },
  }),
};

export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

// Line-by-line reveal for hero headlines. Uses opacity + translate for reliability
// (mask-based reveals are prone to clipping at large font sizes with descenders).
export function MaskedLines({ lines, className = "", delay = 0, testId }) {
  return (
    <div data-testid={testId} className={className}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block"
          initial={{ opacity: 0, y: 32, filter: "blur(6px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{
            duration: 1.0,
            delay: delay + i * 0.14,
            ease: EASE_OUT,
          }}
        >
          {line}
        </motion.span>
      ))}
    </div>
  );
}

// A scroll-triggered fade-up wrapper. Use in place of the old .reveal class.
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className = "",
  once = true,
  amount = 0.2,
  as: Tag = "div",
  testId,
}) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      data-testid={testId}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.8, delay, ease: EASE_OUT }}
    >
      {children}
    </MotionTag>
  );
}
